import { render, staticRenderFns } from "./CardTarjaEnqueteTaNaAreaSportvQRCODE.vue?vue&type=template&id=584a85f6&scoped=true"
import script from "./CardTarjaEnqueteTaNaAreaSportvQRCODE.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteTaNaAreaSportvQRCODE.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteTaNaAreaSportvQRCODE.vue?vue&type=style&index=0&id=584a85f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584a85f6",
  null
  
)

export default component.exports